import {
  createProfileAlert,
  deleteProfilesAlerts,
  fetchAlertsList,
  fetchNewAssets,
  fetchProfilesAlerts,
  updateProfileAlert,
  updateProfileAlertViewed,
  updateProfileAlertsAllViewed,
  updateViewedAssets,
} from './alerts'

const alertsApi = {
  fetchAlertsShortlist: {
    key: 'FETCH_ALERTS_LIST',
    fn: fetchAlertsList,
  },
  fetchProfilesAlerts: {
    key: 'FETCH_PROFILES_ALERTS',
    fn: fetchProfilesAlerts,
  },
  createProfileAlert: {
    key: 'CREATE_PROFILE_ALERT',
    fn: createProfileAlert,
  },
  updateProfileAlert: {
    key: 'UPDATE_PROFILE_ALERT',
    fn: updateProfileAlert,
  },
  deleteProfilesAlerts: {
    key: 'DELETE_PROFILE_ALERTS',
    fn: deleteProfilesAlerts,
  },
  updateProfileAlertViewed: {
    key: 'UPDATE_PROFILE_ALERT_VIEWED',
    fn: updateProfileAlertViewed,
  },
  updateProfileAlertsAllViewed: {
    key: 'UPDATE_PROFILE_ALERTS_ALL_VIEWED',
    fn: updateProfileAlertsAllViewed,
  },
  fetchViewedAssets: {
    key: 'FETCH_VIEWED_ASSETS',
    fn: fetchNewAssets,
  },
  updateViewedAssets: {
    key: 'UPDATE_VIEWED_ASSETS',
    fn: updateViewedAssets,
  },
}

export default alertsApi
